/** 容园 X87S 有线 USB（同 WebHID VID/PID，靠 GET_INFOR 型号 id 区分公版 / 洛天依） */

export const RONGYUAN_X87S_WIRED_VENDOR_ID = 0x3151;
export const RONGYUAN_X87S_WIRED_PRODUCT_ID = 0x504c;

/** GET_INFOR Byte0–3：公版 X87S 有线 */
export const RONGYUAN_X87S_FIRMWARE_ID_STANDARD = 3280;
/** GET_INFOR Byte0–3：X87S 洛天依联名有线 */
export const RONGYUAN_X87S_FIRMWARE_ID_LUOTIANYI = 3502;

/** GET_INFOR 连接方式：6 = USB 有线 */
export const RONGYUAN_GET_INFOR_LINK_USB = 6;

export function isRongyuanX87sWiredUsbConfiguration(
  configuration: unknown
): boolean {
  if (!configuration || typeof configuration !== "object") return false;
  const c = configuration as Record<string, unknown>;
  if (c.solutionRovider !== "rongyuan") return false;
  if (c.is4G === true) return false;
  if (Number(c.vendorId) !== RONGYUAN_X87S_WIRED_VENDOR_ID) return false;
  if (Number(c.productId) !== RONGYUAN_X87S_WIRED_PRODUCT_ID) return false;
  return true;
}

/**
 * 有线 X87S 建卡：按固件型号 id 覆盖 displayname / licensorId（2.4G 不走此函数）。
 */
export function specializeRongyuanX87sWiredByFirmwareId<
  T extends Record<string, unknown>,
>(configuration: T, firmwareDeviceId: number): T {
  if (!isRongyuanX87sWiredUsbConfiguration(configuration)) {
    return configuration;
  }
  if (firmwareDeviceId === RONGYUAN_X87S_FIRMWARE_ID_LUOTIANYI) {
    return {
      ...configuration,
      displayname: "X87S TIANYI",
      licensorId: 1,
    };
  }
  if (firmwareDeviceId === RONGYUAN_X87S_FIRMWARE_ID_STANDARD) {
    const next = { ...configuration, displayname: "X87S" };
    delete next.licensorId;
    return next as T;
  }
  if (typeof console !== "undefined") {
    console.warn(
      `[rongyuan] X87S 有线未知 firmwareDeviceId=${firmwareDeviceId}，按公版建卡`
    );
  }
  const next = { ...configuration, displayname: "X87S" };
  delete next.licensorId;
  return next as T;
}
